export default __webpack_public_path__ + "static/media/menuIcon.2fee2356.svg";